var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.accessDenied)?_c('access-denied',{attrs:{"title":"empresa"}}):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }